/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyMobuileRefineMenuSortBy_itemSearch = {
    readonly displayUriRef: string | null;
    readonly sort: {
        readonly options: ReadonlyArray<{
            readonly urlLabel: string | null;
            readonly linkReference: string | null;
            readonly displayName: string | null;
        } | null> | null;
        readonly currentOption: {
            readonly urlLabel: string | null;
            readonly displayName: string | null;
        } | null;
    } | null;
    readonly " $refType": "BuyMobuileRefineMenuSortBy_itemSearch";
};
export type BuyMobuileRefineMenuSortBy_itemSearch$data = BuyMobuileRefineMenuSortBy_itemSearch;
export type BuyMobuileRefineMenuSortBy_itemSearch$key = {
    readonly " $data"?: BuyMobuileRefineMenuSortBy_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyMobuileRefineMenuSortBy_itemSearch">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyMobuileRefineMenuSortBy_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SortType",
      "kind": "LinkedField",
      "name": "sort",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseSortAvailableOptions",
          "kind": "LinkedField",
          "name": "options",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkReference",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseSortCurrentOption",
          "kind": "LinkedField",
          "name": "currentOption",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
})();
(node as any).hash = '1fbc23840e3912762515bbe1fa7377aa';
export default node;
